import React, { useState, useEffect } from "react";
import { useApp } from "context";
import { IAppointment } from "interfaces";
import { Custom, Modal, Progress } from "components";
import { Box, Grid } from "@mui/material";
import { Helpers } from "utils";

type Props = {
  opened: boolean;
  onClose: () => void;
};

type Sample = {
  scheduledTime: "N/A";
  health360: {
    scores: {
      physicalHealthScore: string;
      healthyLifestyleScore: string;
      SubstancesScore: string;
      mentalHealthScore: string;
      overallScore: string;
    };
  };
};

const health360WixURL =
  "https://www.qubehub.com/booking-calendar/walk-in-clinic-qube-medical";

export const HealthPlan = (props: Props) => {
  const { t, theme, service, locale } = useApp();

  const [health360Appointments, setHealth360Appointments] = useState<
    IAppointment[]
  >([]);
  const [isSample, setIsSample] = useState(false);

  useEffect(() => {
    service.health360.all().then(([status, response]) => {
      const totalHealth360s = response.filter(
        (app: IAppointment) => app.health360
      ).length;

      setIsSample(!totalHealth360s);

      setHealth360Appointments(
        totalHealth360s
          ? response
          : [
              {
                health360: {
                  scores: {
                    physicalHealthScore: "71%",
                    healthyLifestyleScore: "90%",
                    SubstancesScore: "84%",
                    mentalHealthScore: "56%",
                    overallScore: "75%",
                  },
                },
              },
            ]
      );
    });
  }, []);

  const healthPlanContent = (raw: string) => {
    if (!raw) return;

    const lines = raw.split("\n");

    return (
      <div
        style={{
          backgroundColor: theme.palette.background.color,
          padding: "1rem",
          marginTop: "1rem",
          borderRadius: "16px",
        }}
      >
        {lines.map((line, index) => (
          <React.Fragment key={index}>
            {line}
            <br />
          </React.Fragment>
        ))}
      </div>
    );
  };

  return (
    <Custom.Modal
      header={"My Health Plan"}
      opened={props.opened}
      onClose={props.onClose}
    >
      <Box sx={{ position: "relative" }}>
        {health360Appointments ? (
          health360Appointments.length > 0 ? (
            <Custom.Timeline>
              {health360Appointments.map(
                (item: IAppointment | Sample, i: number) => {
                  const date = new Date(item.scheduledTime);
                  const isToday = Helpers.compareTo(date, new Date());
                  return (
                    <Custom.TimelineItem
                      key={i}
                      // title={Helpers.toRelativeDate(
                      //   item.scheduledTime,
                      //   t.relative_date,
                      //   locale
                      // )}
                      // subtitle={"substitute"}
                      // date={item.scheduledTime}
                    >
                      <div>
                        {isSample
                          ? "Sample Health Plan"
                          : Helpers.toRelativeDate(
                              item.scheduledTime,
                              t.relative_date,
                              locale
                            )}
                      </div>
                      {healthPlanContent(
                        item?.health360?.healthPlan ?? "Pending"
                      )}
                    </Custom.TimelineItem>
                  );
                }
              )}
            </Custom.Timeline>
          ) : (
            <Progress.NoRecord height={200} />
          )
        ) : (
          Helpers.generateArray(4).map(function (_, i: number) {
            return <Progress.PlaceholderItem key={i} />;
          })
        )}
      </Box>
    </Custom.Modal>
  );
};
